import { render, staticRenderFns } from "./PostsRejected.vue?vue&type=template&id=af5e6476"
import script from "./PostsRejected.vue?vue&type=script&lang=js"
export * from "./PostsRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports